export default __webpack_public_path__ + "static/O0286-ef8cf7df2fc83d7ebe4c7b9755dd7d37.png";